var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__clock--system icon--style--fill icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8 8 0 00-8-8zm3.439 11.439a.748.748 0 01-1.06 0L7.47 8.53A.749.749 0 017.25 8V3.637a.75.75 0 011.5 0v4.052l2.689 2.69a.749.749 0 010 1.06z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }